<template>
    <div class="carCard">
        <div class="carCard-img">
            <img :src="handleModelImg" alt="Imagem do carro">
        </div>
        <div class="carCard-content">
            <h2 class="carCard-content-title"> {{ modelObj.model }} </h2>
            <div class="carCard-content-price">
                desde <strong>{{ parseFloat(modelObj.price).toFixed(0) | format_thousands }} €</strong>
                <svg @click="openModal(false)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/></svg>
            </div>
            <div class="carCard-content-finance">
                <span> <strong> {{ parseFloat(modelObj.rent).toFixed(2) | format_thousands(true) }}  €/mês</strong>
                    <!-- <svg @click="openModal(true)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/></svg> -->
                </span>
                <span> TAEG: <strong> {{ haddleDecimalsFormat(modelObj.taeg,1) | format_thousands(true, 1) }}%</strong> </span>
            </div>
            <div class="carCard-content-info">
                <p>Valor Financiado</p>
                <p> {{ getFinancedCapital() | format_thousands }} €</p>
                <p>Entrada inicial</p>
                <p> {{ modelObj.maxEntrance | format_thousands }} €</p>
                <p>Mensalidades</p>
                <p> {{ modelObj.nrPayments }} </p>
            </div>
            <router-link class="btn-primary" :to="'/' + handleUrlModelName(modelObj.model) + '/motor'"
            @mouseover.native="handleFetchData ">Selecionar</router-link>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapMutations } from 'vuex';
    import { modalPrice } from '../../../mixins/modalFunctions'

    export default {
        name: 'CarCard',
        components:{},
        mixins: [modalPrice],
        props:{
            modelObj: {type: Object, default: () => { return {}; }},
        },
        data(){ return{
            noModelImg: 'https://www.hyundai.pt/wp-content/themes/hyundai/images/hyundai_no_model.png',
            modalParam: 0,
        }},
        computed:{
            ...mapGetters({
                hasColors: 'images360/modelHasColors',
            }),
            handleModelImg(){
                let img = this.modelObj.modelImg
                if(img == '') return this.noModelImg
                return img
            },
        },
        methods:{
            ...mapMutations({
                changeState: 'resumeData/UPDATE_STATE',
            }),
            openModal(isRent){
                this.$store.commit('modalData/UPDATE_MODALSTATE', {
                    openModal: true,
                    component: 'DefaultModalContent',
                    title: this.setModalTitle(this.handleModalFinTitle, isRent),
                    content: this.setFinanceContent(true, this.handleModalFinData),
                });
                document.body.classList.add('isActive')
            },
            haddleDecimalsFormat(num, decimals=2){
                return parseFloat(num).toFixed(decimals);
            },
            handleFetchData(){
                let obj = this.modelObj
                let id = obj.id

                this.$store.dispatch('images360/fetch360Model', id);
                this.changeState({
                    'model': obj.model,
                    'modelid': id,
                    'basePrice': this.haddleDecimalsFormat(obj.price),
                    'rent': this.haddleDecimalsFormat(obj.rent),
                    'maxMounths': obj.nrPayments,
                    'incialEntry': this.haddleDecimalsFormat(obj.maxEntrance),
                    'financing': this.getFinancedCapital(),
                    'taeg': this.haddleDecimalsFormat(obj.taeg, 1),
                    'modelImg': this.handleModelImg,
                })
            },
            handleUrlModelName(str){
                // let res = str.replace(/ /g, '');
                // console.log(res);
                return str
            },
            getFinancedCapital(){
                let obj = this.modelObj
                let val = obj.price - obj.maxEntrance
                return this.haddleDecimalsFormat(val, 0);
            },
        }
    }
</script>
<style lang="scss">
    @import './CarCard.scss';
</style>
